// import "babel-polyfill";
//import "whatwg-fetch";
import { createRoot } from "react-dom/client";
import App from "./App";
import ModalProvider from "../../shared/context/ModalProvider";
import "what-input";
import { findGetParameter, checkIfDebug } from "./utils/form-utils";
import "./main.scss";

// Dev
window.DISABLE_VALIDATION = checkIfDebug() === "true";
window.SHOW_DEBUG_INFO = findGetParameter("debug-info") === "true";

// TOGGLE DIBS PAYMENTS
window.DisablePayFirstRateNow = window.Config.DisablePayFirstRateNow === true;

// TOGGLE MOBILEPAY
window.DisableMobilePay = window.Config.DisableMobilePay === true;

//TOGGLE CARD PAYMENT
window.DisableCardPayment = window.Config.DisableCardPayment === true;

// TOGGLE Maintenance
window.Maintenance = window.Config.Maintenance === true;

const container = document.getElementById("react-member-registration");
const root = createRoot(container);
root.render(
    <ModalProvider>
        <App />
    </ModalProvider>
);
